window.PDP = {
 "the-paige-shirt": {
  "title": "The Button-Up Beach Tunic",
  "desc": "<p>An elevated take on the classic button-up, designed with an easy, oversized tunic fit and a little extra length for effortless coverage over your swimsuit.</p><p>Wear it open over your suit for the beach or pool, or style it with our Kaitlin Pants or Asher Shorts for an easy matching-set look. The relaxed, oversized fit is intentional—giving it that effortless vacation feel whether you’re wearing it as a cover-up or as part of an outfit.</p><p>The kind of versatile piece that earns a spot in every suitcase.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Front Length",
    "Back Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "31.25",
     "32.25",
     "43"
    ],
    [
     "S",
     "31.75",
     "32.75",
     "45"
    ],
    [
     "M",
     "31.75",
     "32.75",
     "47"
    ],
    [
     "L",
     "32.75",
     "33.75",
     "50"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-0.jpg?v=20630359408703004451792639002",
    "w": 1164,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-1.jpg?v=130252866857493610671792639002",
    "w": 1164,
    "h": 1558
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-2.jpg?v=106398228196828597151792639002",
    "w": 1158,
    "h": 1558
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-3.jpg?v=13089836473407092691792639003",
    "w": 1156,
    "h": 1558
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-4.jpg?v=88366406421819844401792639003",
    "w": 1350,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-5.jpg?v=106235443211992079821792639003",
    "w": 1273,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-6.jpg?v=87708918720489175741792639003",
    "w": 1148,
    "h": 1360
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-7.jpg?v=108755985505819905331792639004",
    "w": 1020,
    "h": 1532
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-8.jpg?v=140881741115977773181792639004",
    "w": 1400,
    "h": 934
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-paige-shirt",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-paige-shirt-stripe": {
  "title": "The Button-Up Beach Tunic",
  "desc": "<p>An elevated take on the classic button-up, designed with an easy, oversized tunic fit and a little extra length for effortless coverage over your swimsuit.</p><p>Wear it open over your suit for the beach or pool, or style it with our Kaitlin Pants or Asher Shorts for an easy matching-set look. The relaxed, oversized fit is intentional—giving it that effortless vacation feel whether you’re wearing it as a cover-up or as part of an outfit.</p><p>The kind of versatile piece that earns a spot in every suitcase.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Front Length",
    "Back Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "31.25",
     "32.25",
     "43"
    ],
    [
     "S",
     "31.75",
     "32.75",
     "45"
    ],
    [
     "M",
     "31.75",
     "32.75",
     "47"
    ],
    [
     "L",
     "32.75",
     "33.75",
     "50"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-0.jpg?v=42826994437688744071792639004",
    "w": 1168,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-1.jpg?v=147602428622007068941792639004",
    "w": 1166,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-2.jpg?v=62308766250532261441792639004",
    "w": 1160,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-3.jpg?v=87946631273376907951792639004",
    "w": 1166,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-4.jpg?v=182018277817939497281792639004",
    "w": 1382,
    "h": 1682
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-5.jpg?v=55218039114072979561792639004",
    "w": 1356,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-shirt-stripe-6.jpg?v=8463968775768637871792639004",
    "w": 1144,
    "h": 1406
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-paige-shirt-stripe",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-shea-t-shirt-dress-white": {
  "title": "The Shea T-Shirt Dress",
  "desc": "<p>Our Shea T shirt dress is now made of 100% bamboo. Making this dress perfectly soft, stretchy and breathable. This is a slim fit dress, we recommend sizing up for a looser more skimming fit. The dress features a modern design, mixing the perfect fit T shirt and a high slit to this maxi dress. The fit is incredibly flattering on all shapes. It skims the body in all the right places and never tight. The styling possibilities for this dress are endless.</p> <p>Blonde Model is 5'10\" wearing a size S, Brunette model is 5'8\" wearing a size XS</p>",
  "fabric": "<p>Our 100% bamboo fabric is chosen for its exceptional softness, fluid drape, and elevated feel—a true luxury essential designed for effortless wear. Derived from fast-growing bamboo, this fabric begins with a natural, renewable resource and is transformed into a textile known for its silk-like smoothness and refined finish.</p><p>Incredibly soft to the touch, bamboo fabric has a cool, almost weightless feel against the skin, making it ideal for warm climates and all-day wear. It drapes beautifully—skimming the body with a fluidity that feels both relaxed and polished, creating that understated elegance that defines The Shore Line.</p><p>Naturally breathable and moisture-wicking, bamboo helps regulate temperature and keep you comfortable in heat and humidity. It’s also known for its gentle, skin-friendly properties, making it an ideal choice for pieces worn close to the body.What sets this fabric apart is its ability to combine luxury with function—it looks elevated, feels indulgent, and performs effortlessly.</p><p>Why we love it:</p><ul><li>Ultra-soft with a silk-like, elevated hand feel</li><li>Lightweight with a fluid, elegant drape</li><li>Breathable and moisture-wicking for warm weather</li><li>Derived from a renewable, fast-growing plant source</li><li>Naturally smooth and gentle on the skin</li></ul><p><b>Care:</b></p><ul><li>Hand Wash Only</li><li>Lay Flat to Dry</li></ul>",
  "chart": {
   "cols": [
    "Size",
    "US size"
   ],
   "rows": [
    [
     "XS",
     "Women's 0 - 2"
    ],
    [
     "S",
     "Women's 2 - 4"
    ],
    [
     "M",
     "Women's 6 - 8"
    ],
    [
     "L",
     "Women's 8 - 10"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-0.jpg?v=156539218139546518411792639008",
    "w": 1160,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-1.jpg?v=172042547133329999451792639008",
    "w": 1160,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-2.jpg?v=105603175821506012891792639008",
    "w": 1154,
    "h": 1558
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-3.jpg?v=141194770735177332861792639008",
    "w": 1154,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-4.jpg?v=146875899101786351961792639008",
    "w": 1164,
    "h": 1568
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-5.jpg?v=95948583475585658471792639008",
    "w": 1148,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-6.jpg?v=144121170811041330551792639008",
    "w": 1148,
    "h": 1566
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-shea-t-shirt-dress-white",
  "care": []
 },
 "the-new-landon": {
  "title": "The New Landon Tank",
  "desc": "<p>The Landon features a bias-cut silhouette, flirty lower back detail, and a scoop neck. Achieve an instant sleek edit by pairing with the Bridgette skirt. Instantly transforms this look into a waist-cinching maxi dress with a cheeky high slit.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "18.5",
     "34.5"
    ],
    [
     "S",
     "19",
     "36.5"
    ],
    [
     "M",
     "19.5",
     "38.5"
    ],
    [
     "L",
     "20",
     "41.5"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-0.jpg?v=106970549623171344891792638999",
    "w": 1158,
    "h": 1554
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-1.jpg?v=34322901149890591371792638999",
    "w": 1154,
    "h": 1128
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-2.jpg?v=1741242465611981881792638999",
    "w": 1160,
    "h": 1532
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-3.jpg?v=38018994053851661061792638998",
    "w": 946,
    "h": 1420
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-4.jpg?v=144444053884491266991792638998",
    "w": 1140,
    "h": 1554
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-new-landon",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-asher-shorts-2": {
  "title": "The Asher Shorts",
  "desc": "<p>The Asher shorts were designed to be seamlessly comfortable, the perfect throw-on-and-get goin’ pair of shorts.</p> <p>Featuring an elastic waistband making them easy to wear high or low waisted, pockets, and scalloped side hem.</p> <p>Our go-to for brunches, walks on the beach, and evening soirees. Pair with the Landon tank for a romper-inspired look! For a more elevated edit, pair this with the Button-Up Beach Tunic. Go ahead, pop your collar!</p> <p>Model is wearing a size XS she is 5'10\"</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25.5",
     "41",
     "3"
    ],
    [
     "S",
     "27.5",
     "43",
     "3"
    ],
    [
     "M",
     "29.5",
     "45",
     "4"
    ],
    [
     "L",
     "32.5",
     "48",
     "4"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-0.jpg?v=86940818010291726931792638986",
    "w": 1146,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-1.jpg?v=76350200647749151291792638986",
    "w": 1146,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-2.jpg?v=157434779746602224271792638988",
    "w": 1146,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-3.jpg?v=124811225611234697671792638988",
    "w": 1146,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-4.jpg?v=3199641748272792691792638988",
    "w": 1168,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2-5.jpg?v=73385569895099850371792638988",
    "w": 1146,
    "h": 1552
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-asher-shorts-2",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-hailey-trouser-1": {
  "title": "The Kaitlin Pants",
  "desc": "<p>The Kaitlin Pants are a wardrobe staple, they sit high on the waist before falling into a relaxed wide-leg silhouette, leaving you looking tailored in all the right places.</p> <p>Featuring an elastic waistband for added comfort and pocket detail for your lip gloss (You’re very welcome)! We recommend styling with the Landon Tank for a cute jumpsuit look!</p> <p>Model is 5'10\" wearing a size XS</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Rise",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38",
     "11.5",
     "30"
    ],
    [
     "S",
     "27",
     "40",
     "12.125",
     "30"
    ],
    [
     "M",
     "29",
     "42",
     "12.75",
     "32"
    ],
    [
     "L",
     "32",
     "45",
     "13.875",
     "32"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-0.jpg?v=26487112681316058751792638993",
    "w": 1102,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-1.jpg?v=100956783285475054281792638993",
    "w": 1144,
    "h": 1548
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-2.jpg?v=133179679520234666831792638993",
    "w": 1082,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-3.jpg?v=177308575423355734661792638993",
    "w": 1094,
    "h": 1546
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-4.jpg?v=161275036559996540231792638993",
    "w": 828,
    "h": 1110
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-5.jpg?v=95108098150557317501792638993",
    "w": 1078,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-6.jpg?v=80421248305286616591792638993",
    "w": 1090,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-7.jpg?v=118145025786179360801792638995",
    "w": 1100,
    "h": 1442
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-8.jpg?v=9048708099378745101792638995",
    "w": 1178,
    "h": 1474
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-9.jpg?v=160139099103884521661792638995",
    "w": 978,
    "h": 1558
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-hailey-trouser-1",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-bridgett-skirt-1": {
  "title": "The Bridgett Skirt",
  "desc": "<p>The Bridgett will make you feel effortlessly sexy. This flowy maxi skirt hugs you in all the right places, has a cheeky slit to show off your legs, and an elastic waistband for added comfort!</p> <p>Take a break from the pool and slide it over your favorite one-piece suit and grab a quick lunch. One pieces are essentially bodysuits, right? Instantly pull the whole moment together by pairing it with the Landon tank, cute sandals, and your beach tote.</p> <p>Model is 5' 10\" wearing a size XS | Studio model is 5' 10\" wearing a size L</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38"
    ],
    [
     "S",
     "27",
     "40"
    ],
    [
     "M",
     "29",
     "42"
    ],
    [
     "L",
     "32",
     "45"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-0.jpg?v=150953212131593830471792638990",
    "w": 1351,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-1.jpg?v=106657504376986191051792638990",
    "w": 1166,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-2.jpg?v=34939390498212578931792638990",
    "w": 1022,
    "h": 1546
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-3.jpg?v=176570779756364009831792638990",
    "w": 1351,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-4.jpg?v=148296910070172498261792638991",
    "w": 1166,
    "h": 1560
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-5.jpg?v=115292688795759266591792638992",
    "w": 1166,
    "h": 1562
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-6.jpg?v=92130933045859119771792638992",
    "w": 1016,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-7.jpg?v=61205040279726081801792638992",
    "w": 1351,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1-8.jpg?v=18648394411719566921792638991",
    "w": 1200,
    "h": 1800
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-bridgett-skirt-1",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-paige-beach-shirt": {
  "title": "The Button-Up Beach Tunic",
  "desc": "<p>An elevated take on the classic button-up, designed with an easy, oversized tunic fit and a little extra length for effortless coverage over your swimsuit.</p><p>Wear it open over your suit for the beach or pool, or style it with our Kaitlin Pants or Asher Shorts for an easy matching-set look. The relaxed, oversized fit is intentional—giving it that effortless vacation feel whether you’re wearing it as a cover-up or as part of an outfit.</p><p>The kind of versatile piece that earns a spot in every suitcase.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Front Length",
    "Back Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "31.25",
     "32.25",
     "43"
    ],
    [
     "S",
     "31.75",
     "32.75",
     "45"
    ],
    [
     "M",
     "31.75",
     "32.75",
     "47"
    ],
    [
     "L",
     "32.75",
     "33.75",
     "50"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-0.jpg?v=145563845123567924491792639001",
    "w": 1150,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-1.jpg?v=106892749078060127861792639001",
    "w": 1156,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-2.jpg?v=23432602312418133291792639001",
    "w": 1146,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-3.jpg?v=149504051749500614801792639002",
    "w": 1136,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-4.jpg?v=137042074852451469051792639002",
    "w": 1152,
    "h": 1560
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-5.jpg?v=48104486139569917701792639002",
    "w": 1351,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-6.jpg?v=9608756630435893231792639002",
    "w": 1351,
    "h": 1800
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-paige-beach-shirt",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-asher-shorts-3": {
  "title": "The Asher Shorts",
  "desc": "<p>The Asher shorts were designed to be seamlessly comfortable, the perfect throw-on-and-get goin’ pair of shorts.</p> <p>Featuring an elastic waistband making them easy to wear high or low waisted, pockets, and scalloped side hem.</p> <p>Our go-to for brunches, walks on the beach, and evening soirees. Pair with the Landon tank for a romper-inspired look! For a more elevated edit, pair this with the Button-Up Beach Tunic. Go ahead, pop your collar!</p> <p>Model is wearing a size XS and is 5'10\"</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25.5",
     "41",
     "3"
    ],
    [
     "S",
     "27.5",
     "43",
     "3"
    ],
    [
     "M",
     "29.5",
     "45",
     "4"
    ],
    [
     "L",
     "32.5",
     "48",
     "4"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-0.jpg?v=80489529548031326031792638988",
    "w": 1246,
    "h": 1562
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-1.jpg?v=43767709912439064911792638988",
    "w": 1162,
    "h": 1562
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-2.jpg?v=88366406421819844401792638988",
    "w": 1350,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-3.jpg?v=182391799136779069571792638988",
    "w": 1158,
    "h": 1554
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-4.jpg?v=87708918720489175741792638988",
    "w": 1148,
    "h": 1360
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-asher-shorts-3",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-new-landon-tank": {
  "title": "The New Landon Tank",
  "desc": "<p>The Landon features a scoop neck with a flirty lower back detail. Achieve an instant sleek edit by pairing with the Bridgette skirt. Instantly transforms this look into a waist-cinching maxi dress with a cheeky high slit.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "18.5",
     "34.5"
    ],
    [
     "S",
     "19",
     "36.5"
    ],
    [
     "M",
     "19.5",
     "38.5"
    ],
    [
     "L",
     "20",
     "41.5"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-0.jpg?v=69741987833773057231792638998",
    "w": 1160,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-1.jpg?v=51314154234938497551792638998",
    "w": 1130,
    "h": 1542
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-2.jpg?v=64163745243172266051792638998",
    "w": 1218,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-3.jpg?v=133716997316741911641792638998",
    "w": 1148,
    "h": 1548
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-4.jpg?v=49676383277950353121792638998",
    "w": 1130,
    "h": 1250
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-5.jpg?v=156429915332881816891792638998",
    "w": 1130,
    "h": 1438
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-6.jpg?v=126973972393882120021792639001",
    "w": 890,
    "h": 1476
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-new-landon-tank-7.jpg?v=21246937632211625741792639001",
    "w": 1130,
    "h": 1476
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-new-landon-tank",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-shea-t-shirt-dress": {
  "title": "The Shea T-Shirt Dress",
  "desc": "<p>Our Shea T shirt dress is now made of 100% bamboo. Making this dress perfectly soft, stretchy and breathable. This is a slim fit dress, we recommend sizing up for a looser more skimming fit. The dress features a modern design, mixing the perfect fit T shirt and a high slit to this maxi dress. The fit is incredibly flattering on all shapes. It skims the body in all the right places and never tight. The styling possibilities for this dress are endless.</p> <p>Model is 5'10\" wearing a size XS in black. Model is wearing a size S in white variant.</p>",
  "fabric": "<p>Our 100% bamboo fabric is chosen for its exceptional softness, fluid drape, and elevated feel—a true luxury essential designed for effortless wear. Derived from fast-growing bamboo, this fabric begins with a natural, renewable resource and is transformed into a textile known for its silk-like smoothness and refined finish.</p><p>Incredibly soft to the touch, bamboo fabric has a cool, almost weightless feel against the skin, making it ideal for warm climates and all-day wear. It drapes beautifully—skimming the body with a fluidity that feels both relaxed and polished, creating that understated elegance that defines The Shore Line.</p><p>Naturally breathable and moisture-wicking, bamboo helps regulate temperature and keep you comfortable in heat and humidity. It’s also known for its gentle, skin-friendly properties, making it an ideal choice for pieces worn close to the body.What sets this fabric apart is its ability to combine luxury with function—it looks elevated, feels indulgent, and performs effortlessly.</p><p>Why we love it:</p><ul><li>Ultra-soft with a silk-like, elevated hand feel</li><li>Lightweight with a fluid, elegant drape</li><li>Breathable and moisture-wicking for warm weather</li><li>Derived from a renewable, fast-growing plant source</li><li>Naturally smooth and gentle on the skin</li></ul><p><b>Care:</b></p><ul><li>Hand Wash Only</li><li>Lay Flat to Dry</li></ul>",
  "chart": {
   "cols": [
    "Size",
    "US size"
   ],
   "rows": [
    [
     "XS",
     "Women's 0 - 2"
    ],
    [
     "S",
     "Women's 2 - 4"
    ],
    [
     "M",
     "Women's 6 - 8"
    ],
    [
     "L",
     "Women's 8 - 10"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-0.jpg?v=54570550126195004201792639006",
    "w": 1252,
    "h": 1546
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-1.jpg?v=140235477530670641571792639006",
    "w": 1146,
    "h": 1562
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-2.jpg?v=490464256326120761792639008",
    "w": 1154,
    "h": 1528
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-3.jpg?v=63400704904154044451792639008",
    "w": 1122,
    "h": 1204
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-4.jpg?v=47564699822924873531792639008",
    "w": 1096,
    "h": 1526
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-5.jpg?v=94086916523071984471792639008",
    "w": 1154,
    "h": 1550
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-shea-t-shirt-dress",
  "care": []
 },
 "the-hailey-trouser-3": {
  "title": "The Kaitlin Pants",
  "desc": "<p>The Kaitlin Pants are a wardrobe staple, they sit high on the waist before falling into a relaxed wide-leg silhouette, leaving you looking tailored in all the right places.</p> <p>Featuring an elastic waistband for added comfort and pocket detail for your lip gloss (You’re very welcome)! We recommend styling with the Landon Tank for a cute jumpsuit look!</p> <p>Model is 5'9\" wearing a size XS.</p> <p>Please note, the 'Long' inseam is 34”. Please allow an additional 2 weeks for long variant.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Rise",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38",
     "11.5",
     "30"
    ],
    [
     "S",
     "27",
     "40",
     "12.125",
     "30"
    ],
    [
     "M",
     "29",
     "42",
     "12.75",
     "32"
    ],
    [
     "L",
     "32",
     "45",
     "13.875",
     "32"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-0.jpg?v=22010523419846391621792638995",
    "w": 1350,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-1.jpg?v=19734144707524378751792638995",
    "w": 1158,
    "h": 1536
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-2.jpg?v=156610685630661670421792638995",
    "w": 1152,
    "h": 1558
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-3.jpg?v=44339318708335572801792638995",
    "w": 1000,
    "h": 1227
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-4.jpg?v=93274224525624381301792638997",
    "w": 1162,
    "h": 1548
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-5.jpg?v=64983172550612429511792638997",
    "w": 1016,
    "h": 1186
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-6.jpg?v=180929150714637458411792638997",
    "w": 1152,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-7.jpg?v=68457956874247857031792638997",
    "w": 1154,
    "h": 1562
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-8.jpg?v=139879427553136782151792638997",
    "w": 917,
    "h": 1147
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3-9.jpg?v=118409878499530364421792638997",
    "w": 980,
    "h": 1040
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-hailey-trouser-3",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-bridgett-skirt": {
  "title": "The Bridgett Skirt",
  "desc": "<p>The Bridgett will make you feel effortlessly sexy. This flowy maxi skirt hugs you in all the right places, has a cheeky slit to show off your legs, and an elastic waistband for added comfort!</p> <p>Take a break from the pool and slide it over your favorite one-piece suit and grab a quick lunch. One pieces are essentially bodysuits, right? Instantly pull the whole moment together by pairing it with the Landon tank, cute sandals, and your beach tote.</p> <p>Model is 5'9\" wearing a size XS</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38"
    ],
    [
     "S",
     "27",
     "40"
    ],
    [
     "M",
     "29",
     "42"
    ],
    [
     "L",
     "32",
     "45"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-0.jpg?v=103500720212843713211792638990",
    "w": 1290,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-1.jpg?v=55529933291754059771792638991",
    "w": 1224,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-2.jpg?v=158704798893631879291792638991",
    "w": 1046,
    "h": 1554
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-3.jpg?v=105525426805621580211792638991",
    "w": 1018,
    "h": 1530
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-4.jpg?v=8591487526837025871792638992",
    "w": 1220,
    "h": 1542
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-5.jpg?v=88797270124675210531792638992",
    "w": 1144,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-6.jpg?v=1244733923702528901792638992",
    "w": 1028,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-7.jpg?v=43534223986728403081792638993",
    "w": 1218,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-8.jpg?v=57685217317126401791792638993",
    "w": 1162,
    "h": 1552
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-bridgett-skirt",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-shea-long-sleeve-t-shirt-dress": {
  "title": "The Shea Long Sleeve T-Shirt Dress",
  "desc": "<p>Our Shea T shirt dress is now made of 100% bamboo. Making this dress perfectly soft, stretchy and breathable. This is a slim fit dress, we recommend sizing up for a looser more skimming fit. The dress features a modern design, mixing the perfect fit T shirt and a high slit to this maxi dress. The fit is incredibly flattering on all shapes. It skims the body in all the right places and never tight. The styling possibilities for this dress are endless.</p> <p>Model is 5'8\" wearing a size XS</p>",
  "fabric": "<p>Our 100% bamboo fabric is chosen for its exceptional softness, fluid drape, and elevated feel—a true luxury essential designed for effortless wear. Derived from fast-growing bamboo, this fabric begins with a natural, renewable resource and is transformed into a textile known for its silk-like smoothness and refined finish.</p><p>Incredibly soft to the touch, bamboo fabric has a cool, almost weightless feel against the skin, making it ideal for warm climates and all-day wear. It drapes beautifully—skimming the body with a fluidity that feels both relaxed and polished, creating that understated elegance that defines The Shore Line.</p><p>Naturally breathable and moisture-wicking, bamboo helps regulate temperature and keep you comfortable in heat and humidity. It’s also known for its gentle, skin-friendly properties, making it an ideal choice for pieces worn close to the body.What sets this fabric apart is its ability to combine luxury with function—it looks elevated, feels indulgent, and performs effortlessly.</p><p>Why we love it:</p><ul><li>Ultra-soft with a silk-like, elevated hand feel</li><li>Lightweight with a fluid, elegant drape</li><li>Breathable and moisture-wicking for warm weather</li><li>Derived from a renewable, fast-growing plant source</li><li>Naturally smooth and gentle on the skin</li></ul><p><b>Care:</b></p><ul><li>Hand Wash Only</li><li>Lay Flat to Dry</li></ul>",
  "chart": {
   "cols": [
    "Size",
    "US size"
   ],
   "rows": [
    [
     "XS",
     "Women's 0 - 2"
    ],
    [
     "S",
     "Women's 2 - 4"
    ],
    [
     "M",
     "Women's 6 - 8"
    ],
    [
     "L",
     "Women's 8 - 10"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-0.jpg?v=10214762205855513861792639006",
    "w": 1158,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-1.jpg?v=146937835180838061331792639006",
    "w": 1158,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-2.jpg?v=156523878599685835981792639006",
    "w": 1150,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-3.jpg?v=63877329246589419841792639006",
    "w": 1140,
    "h": 1536
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-4.jpg?v=133247709665632891841792639006",
    "w": 1148,
    "h": 1544
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-5.jpg?v=14400031099035854741792639006",
    "w": 1144,
    "h": 1550
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-shea-long-sleeve-t-shirt-dress",
  "care": []
 },
 "the-hailey-trouser": {
  "title": "The Kaitlin Pants",
  "desc": "<p>The Kaitlin Pants are a wardrobe staple, they sit high on the waist before falling into a relaxed wide-leg silhouette, leaving you looking tailored in all the right places.</p> <p>Featuring an elastic waistband for added comfort and pocket detail for your lip gloss (You’re very welcome)! We recommend styling with the Landon Tank for a cute jumpsuit look!</p> <p>Model is 5'9\" wearing a size XS</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Rise",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38",
     "11.5",
     "30"
    ],
    [
     "S",
     "27",
     "40",
     "12.125",
     "30"
    ],
    [
     "M",
     "29",
     "42",
     "12.75",
     "32"
    ],
    [
     "L",
     "32",
     "45",
     "13.875",
     "32"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-0.jpg?v=82050517509836242741792638993",
    "w": 1341,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1.jpg?v=121899355790301199611792638995",
    "w": 1335,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-2.jpg?v=40762993801004794921792638995",
    "w": 1340,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-3.jpg?v=75615996380982464871792638997",
    "w": 1340,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-4.jpg?v=117535506394215970261792638997",
    "w": 1344,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-5.jpg?v=38594958083948289771792638997",
    "w": 1338,
    "h": 1800
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-hailey-trouser",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-paige-beach-shirt-1": {
  "title": "The Button-Up Beach Tunic",
  "desc": "<p>An elevated take on the classic button-up, designed with an easy, oversized tunic fit and a little extra length for effortless coverage over your swimsuit.</p><p>Wear it open over your suit for the beach or pool, or style it with our Kaitlin Pants or Asher Shorts for an easy matching-set look. The relaxed, oversized fit is intentional—giving it that effortless vacation feel whether you’re wearing it as a cover-up or as part of an outfit.</p><p>The kind of versatile piece that earns a spot in every suitcase.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Front Length",
    "Back Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "31.25",
     "32.25",
     "43"
    ],
    [
     "S",
     "31.75",
     "32.75",
     "45"
    ],
    [
     "M",
     "31.75",
     "32.75",
     "47"
    ],
    [
     "L",
     "32.75",
     "33.75",
     "50"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-1-0.jpg?v=161985649249749691091792639001",
    "w": 1346,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-1-1.jpg?v=85582750540244649301792639001",
    "w": 1352,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-1-2.jpg?v=82050517509836242741792639001",
    "w": 1341,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-1-3.jpg?v=95766132594413078411792639001",
    "w": 1351,
    "h": 1800
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-paige-beach-shirt-1",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-vacation-pants-copy": {
  "title": "The Vacation Pant",
  "desc": "<p>Our new Vacation Pants are a wardrobe staple, they sit high on the waist before falling into a relaxed wide-leg silhouette, leaving you looking tailored in all the right places.</p> <p>Featuring an elastic waistband all the way around for added comfort and pocket detail. We recommend styling with the Button-Up Beach Tunic.</p> <p>Model is 5'9\" wearing a size XS</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Rise",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38",
     "11.5",
     "30"
    ],
    [
     "S",
     "27",
     "40",
     "12.125",
     "30"
    ],
    [
     "M",
     "29",
     "42",
     "12.75",
     "32"
    ],
    [
     "L",
     "32",
     "45",
     "13.875",
     "32"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-0.jpg?v=128134704218493698191792639011",
    "w": 1148,
    "h": 1552
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-1.jpg?v=75824447776702312441792639011",
    "w": 1026,
    "h": 1560
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-2.jpg?v=161365781709779502661792639011",
    "w": 1136,
    "h": 1498
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-3.jpg?v=72892757779841833721792639011",
    "w": 1156,
    "h": 1554
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-4.jpg?v=60523474368494365111792639011",
    "w": 1164,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-vacation-pants-copy-5.jpg?v=176715006681896207751792639011",
    "w": 1148,
    "h": 1554
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-vacation-pants-copy",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-beach-shirt": {
  "title": "The Button-Up Beach Tunic",
  "desc": "<p>An elevated take on the classic button-up, designed with an easy, oversized tunic fit and a little extra length for effortless coverage over your swimsuit.</p><p>Wear it open over your suit for the beach or pool, or style it with our Kaitlin Pants or Asher Shorts for an easy matching-set look. The relaxed, oversized fit is intentional—giving it that effortless vacation feel whether you’re wearing it as a cover-up or as part of an outfit.</p><p>The kind of versatile piece that earns a spot in every suitcase.</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Front Length",
    "Back Length",
    "Chest"
   ],
   "rows": [
    [
     "XS",
     "31.25",
     "32.25",
     "43"
    ],
    [
     "S",
     "31.75",
     "32.75",
     "45"
    ],
    [
     "M",
     "31.75",
     "32.75",
     "47"
    ],
    [
     "L",
     "32.75",
     "33.75",
     "50"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-beach-shirt-0.jpg?v=33446034000690471051792638990",
    "w": 1012,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-beach-shirt-1.jpg?v=32712552635036967971792638990",
    "w": 1146,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-beach-shirt-2.jpg?v=163077574546712259701792638990",
    "w": 1156,
    "h": 1550
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-beach-shirt-3.jpg?v=141159294632176701631792638990",
    "w": 1152,
    "h": 1540
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-beach-shirt-4.jpg?v=57476605290127438941792638990",
    "w": 1080,
    "h": 1080
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-beach-shirt",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-asher-shorts": {
  "title": "The Asher Shorts",
  "desc": "<p>The Asher shorts were designed to be seamlessly comfortable, the perfect throw-on-and-get goin’ pair of shorts.</p> <p>Featuring an elastic waistband making them easy to wear high or low waisted, pockets, and scalloped side hem.</p> <p>Our go-to for brunches, walks on the beach, and evening soirees. Pair with the Landon tank for a romper-inspired look! For a more elevated edit, pair this with the Button-Up Beach Tunic. Go ahead, pop your collar!</p> <p>Model is wearing a size XS she is 5'8\"</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25.5",
     "41",
     "3"
    ],
    [
     "S",
     "27.5",
     "43",
     "3"
    ],
    [
     "M",
     "29.5",
     "45",
     "4"
    ],
    [
     "L",
     "32.5",
     "48",
     "4"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-0.jpg?v=149620852841069170871792638986",
    "w": 1012,
    "h": 1800
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-1.jpg?v=177458428207045222201792638986",
    "w": 1164,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-2.jpg?v=53110048757146704481792638988",
    "w": 1158,
    "h": 1548
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3.jpg?v=136365263365311515351792638988",
    "w": 1154,
    "h": 1548
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-4.jpg?v=181793046873221439681792638990",
    "w": 1160,
    "h": 1556
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-5.jpg?v=57476605290127438941792638990",
    "w": 1080,
    "h": 1080
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-asher-shorts",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-kaitlin-pants": {
  "title": "The Kaitlin Pants",
  "desc": "<p>The Kaitlin Pants are a wardrobe staple, they sit high on the waist before falling into a relaxed wide-leg silhouette, leaving you looking tailored in all the right places.</p> <p>Featuring an elastic waistband for added comfort and pocket detail for your lip gloss (You’re very welcome)! We recommend styling with the Landon Tank for a cute jumpsuit look!</p> <p>Model is 5'7\" wearing a size XS and long inseam 34\"</p>",
  "fabric": "<p>100% Eco Rayon</p><p>Crafted from natural cellulose fibers derived from renewable plant sources, our eco rayon offers the perfect balance of softness, breathability, and fluid movement. Unlike fully synthetic fabrics, rayon begins with nature—typically wood pulp—then is transformed into a fiber that feels luxuriously smooth against the skin.</p><p>Lightweight and airy, this fabric is designed for warm, sun-soaked days. It has a silk-like drape and flow, moving effortlessly with the body to create that relaxed, undone elegance that defines an endless summer wardrobe.</p><p>Highly breathable and naturally absorbent, eco rayon keeps you cool and comfortable in heat and humidity—making it ideal for travel, beach days, and everything in between.</p><p>Our eco rayon is also biodegradable, meaning it can break down more naturally over time compared to fully synthetic fibers, supporting a more conscious approach to dressing.</p>",
  "chart": {
   "cols": [
    "Size",
    "Waist",
    "Hip",
    "Rise",
    "Inseam"
   ],
   "rows": [
    [
     "XS",
     "25",
     "38",
     "11.5",
     "30"
    ],
    [
     "S",
     "27",
     "40",
     "12.125",
     "30"
    ],
    [
     "M",
     "29",
     "42",
     "12.75",
     "32"
    ],
    [
     "L",
     "32",
     "45",
     "13.875",
     "32"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-kaitlin-pants-0.jpg?v=133969318620886884901792638997",
    "w": 1122,
    "h": 1402
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-kaitlin-pants-1.jpg?v=107828637072191248671792638999",
    "w": 1158,
    "h": 1544
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-kaitlin-pants",
  "care": [
   "Machine Wash Cold",
   "Lay Flat to Dry",
   "Dry Clean Optional"
  ]
 },
 "the-shea-long-sleeve-t-shirt-dress-white": {
  "title": "The Shea Long Sleeve T-Shirt Dress",
  "desc": "<p>Our Shea T shirt dress in White is made of 100% bamboo. Making this dress perfectly soft, stretchy and breathable. This is a slim fit dress, we recommend sizing up for a looser more skimming fit. The dress features a modern design, mixing the perfect fit T shirt and a high slit to this maxi dress. The fit is incredibly flattering on all shapes. It skims the body in all the right places and never tight. The styling possibilities for this dress are endless.</p> <p>Model is 5'8\" wearing a size XS</p>",
  "fabric": "<p>Our 100% bamboo fabric is chosen for its exceptional softness, fluid drape, and elevated feel—a true luxury essential designed for effortless wear. Derived from fast-growing bamboo, this fabric begins with a natural, renewable resource and is transformed into a textile known for its silk-like smoothness and refined finish.</p><p>Incredibly soft to the touch, bamboo fabric has a cool, almost weightless feel against the skin, making it ideal for warm climates and all-day wear. It drapes beautifully—skimming the body with a fluidity that feels both relaxed and polished, creating that understated elegance that defines The Shore Line.</p><p>Naturally breathable and moisture-wicking, bamboo helps regulate temperature and keep you comfortable in heat and humidity. It’s also known for its gentle, skin-friendly properties, making it an ideal choice for pieces worn close to the body.What sets this fabric apart is its ability to combine luxury with function—it looks elevated, feels indulgent, and performs effortlessly.</p><p>Why we love it:</p><ul><li>Ultra-soft with a silk-like, elevated hand feel</li><li>Lightweight with a fluid, elegant drape</li><li>Breathable and moisture-wicking for warm weather</li><li>Derived from a renewable, fast-growing plant source</li><li>Naturally smooth and gentle on the skin</li></ul><p><b>Care:</b></p><ul><li>Hand Wash Only</li><li>Lay Flat to Dry</li></ul>",
  "chart": {
   "cols": [
    "Size",
    "US size"
   ],
   "rows": [
    [
     "XS",
     "Women's 0 - 2"
    ],
    [
     "S",
     "Women's 2 - 4"
    ],
    [
     "M",
     "Women's 6 - 8"
    ],
    [
     "L",
     "Women's 8 - 10"
    ]
   ]
  },
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-0.jpg?v=62147676084297339841792639006",
    "w": 1080,
    "h": 1441
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-1.jpg?v=95378700971394639241792639006",
    "w": 1070,
    "h": 1470
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-2.jpg?v=81145097735864854091792639006",
    "w": 1080,
    "h": 1438
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-shea-long-sleeve-t-shirt-dress-white",
  "care": []
 },
 "search-for-surf-tour-sweatshirt-tan-on-tan": {
  "title": "Search for Surf Tour Sweatshirt - Tan on Tan",
  "desc": "<p>For the days that start at the beach and end wherever the sun takes you.</p><p>Our Search for Surf Tour Sweatshirt brings an effortlessly cool, vintage surf feel to your everyday wardrobe. Made from a soft cotton-blend fabric with a cozy fleece interior, it's the perfect throw-on layer for cool mornings, beach days, and everything in between.</p><p>Designed with a relaxed, unisex fit and our signature Search for Surf Tour graphic.</p><p><b>Details</b></p><ul><li>Soft cotton-blend fabric with fleece interior</li><li>Relaxed, unisex fit</li><li>Available in Small, Medium, and Large</li><li>Four colorways: Tan on Tan, Black on Black, White with Royal Blue, and Red on Red</li><li>Model is wearing a size Small</li></ul><p><b>Fit Note:</b> Unisex sizing for a relaxed, easy fit. Size down for a more fitted look.</p>",
  "fabric": "<p>Soft cotton-blend fabric with fleece interior.</p>",
  "chart": null,
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-tan-on-tan-0.jpg?v=121839170851153147751792638986",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-tan-on-tan-1.jpg?v=44419471388261449271792638986",
    "w": 1050,
    "h": 1400
   }
  ],
  "url": "https://thisistheshoreline.com/products/search-for-surf-tour-sweatshirt-tan-on-tan",
  "care": []
 },
 "search-for-surf-tour-sweatshirt-black-on-black": {
  "title": "Search for Surf Tour Sweatshirt - Black on Black",
  "desc": "<p>For the days that start at the beach and end wherever the sun takes you.</p><p>Our Search for Surf Tour Sweatshirt brings an effortlessly cool, vintage surf feel to your everyday wardrobe. Made from a soft cotton-blend fabric with a cozy fleece interior, it's the perfect throw-on layer for cool mornings, beach days, and everything in between.</p><p>Designed with a relaxed, unisex fit and our signature Search for Surf Tour graphic.</p><p><b>Details</b></p><ul><li>Soft cotton-blend fabric with fleece interior</li><li>Relaxed, unisex fit</li><li>Available in Small, Medium, and Large</li><li>Four colorways: Tan on Tan, Black on Black, White with Royal Blue, and Red on Red</li><li>Model is wearing a size Small</li></ul><p><b>Fit Note:</b> Unisex sizing for a relaxed, easy fit. Size down for a more fitted look.</p>",
  "fabric": "<p>Soft cotton-blend fabric with fleece interior.</p>",
  "chart": null,
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-black-on-black-0.jpg?v=59848704596974823471792638986",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-black-on-black-1.jpg?v=52251223931838861041792638986",
    "w": 1050,
    "h": 1400
   }
  ],
  "url": "https://thisistheshoreline.com/products/search-for-surf-tour-sweatshirt-black-on-black",
  "care": []
 },
 "search-for-surf-tour-sweatshirt-white-with-royal-blue": {
  "title": "Search for Surf Tour Sweatshirt - White with Royal Blue",
  "desc": "<p>For the days that start at the beach and end wherever the sun takes you.</p><p>Our Search for Surf Tour Sweatshirt brings an effortlessly cool, vintage surf feel to your everyday wardrobe. Made from a soft cotton-blend fabric with a cozy fleece interior, it's the perfect throw-on layer for cool mornings, beach days, and everything in between.</p><p>Designed with a relaxed, unisex fit and our signature Search for Surf Tour graphic.</p><p><b>Details</b></p><ul><li>Soft cotton-blend fabric with fleece interior</li><li>Relaxed, unisex fit</li><li>Available in Small, Medium, and Large</li><li>Four colorways: Tan on Tan, Black on Black, White with Royal Blue, and Red on Red</li><li>Model is wearing a size Small</li></ul><p><b>Fit Note:</b> Unisex sizing for a relaxed, easy fit. Size down for a more fitted look.</p>",
  "fabric": "<p>Soft cotton-blend fabric with fleece interior.</p>",
  "chart": null,
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-white-with-royal-blue-0.jpg?v=58974402308831920381792638986",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-white-with-royal-blue-1.jpg?v=73186267701948479701792638986",
    "w": 1050,
    "h": 1400
   }
  ],
  "url": "https://thisistheshoreline.com/products/search-for-surf-tour-sweatshirt-white-with-royal-blue",
  "care": []
 },
 "search-for-surf-tour-sweatshirt-red-on-red": {
  "title": "Search for Surf Tour Sweatshirt - Red on Red",
  "desc": "<p>For the days that start at the beach and end wherever the sun takes you.</p><p>Our Search for Surf Tour Sweatshirt brings an effortlessly cool, vintage surf feel to your everyday wardrobe. Made from a soft cotton-blend fabric with a cozy fleece interior, it's the perfect throw-on layer for cool mornings, beach days, and everything in between.</p><p>Designed with a relaxed, unisex fit and our signature Search for Surf Tour graphic.</p><p><b>Details</b></p><ul><li>Soft cotton-blend fabric with fleece interior</li><li>Relaxed, unisex fit</li><li>Available in Small, Medium, and Large</li><li>Four colorways: Tan on Tan, Black on Black, White with Royal Blue, and Red on Red</li><li>Model is wearing a size Small</li></ul><p><b>Fit Note:</b> Unisex sizing for a relaxed, easy fit. Size down for a more fitted look.</p>",
  "fabric": "<p>Soft cotton-blend fabric with fleece interior.</p>",
  "chart": null,
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-red-on-red-0.jpg?v=98397186268735183851792638986",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-search-for-surf-tour-sweatshirt-red-on-red-1.jpg?v=88617733844567283901792638986",
    "w": 1050,
    "h": 1400
   }
  ],
  "url": "https://thisistheshoreline.com/products/search-for-surf-tour-sweatshirt-red-on-red",
  "care": []
 },
 "the-travel-t": {
  "title": "The Travel T",
  "desc": "<p>The T-shirt you’ll want to pack every time. Made from 100% bamboo, the Travel T is incredibly soft, lightweight, and drapes beautifully. The relaxed, roomy fit is slightly cropped to hit perfectly at the waistband of our Kaitlin Pants—easy, effortless, and already styled for you.</p><p>Wear it with the Kaitlin Pants as a set, throw it on with the Bridgett Skirt, or pair it with your favorite denim. It’s an easy alternative to our Beach Tunic when you want something a little more casual, but just as versatile.</p>",
  "fabric": "<p>100% Bamboo</p><p>Our 100% bamboo fabric is chosen for its exceptional softness, fluid drape, and elevated feel—a true luxury essential designed for effortless wear. Derived from fast-growing bamboo, this fabric begins with a natural, renewable resource and is transformed into a textile known for its silk-like smoothness and refined finish.</p><p>Incredibly soft to the touch, bamboo fabric has a cool, almost weightless feel against the skin, making it ideal for warm climates and all-day wear. It drapes beautifully—skimming the body with a fluidity that feels both relaxed and polished, creating that understated elegance that defines The Shore Line.</p><p>Naturally breathable and moisture-wicking, bamboo helps regulate temperature and keep you comfortable in heat and humidity. It’s also known for its gentle, skin-friendly properties, making it an ideal choice for pieces worn close to the body. What sets this fabric apart is its ability to combine luxury with function—it looks elevated, feels indulgent, and performs effortlessly.</p><p><b>Why we love it:</b></p><ul><li>Ultra-soft with a silk-like, elevated hand feel</li><li>Lightweight with a fluid, elegant drape</li><li>Breathable and moisture-wicking for warm weather</li><li>Derived from a renewable, fast-growing plant source</li><li>Naturally smooth and gentle on the skin</li></ul>",
  "chart": null,
  "imgs": [
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-0.jpg?v=97012051214983777821792639008",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-1.jpg?v=139451696524032563311792639010",
    "w": 1050,
    "h": 1400
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-2.jpg?v=71808928020834459921792639010",
    "w": 1000,
    "h": 1470
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-3.jpg?v=139137159620955349291792639009",
    "w": 1000,
    "h": 1473
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-4.jpg?v=15759720107176739601792639010",
    "w": 1000,
    "h": 1447
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-5.jpg?v=127146890444292550041792639010",
    "w": 1000,
    "h": 1483
   },
   {
    "src": "//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-travel-t-6.jpg?v=58320397816813152321792639010",
    "w": 1000,
    "h": 1482
   }
  ],
  "url": "https://thisistheshoreline.com/products/the-travel-t",
  "care": [
   "Hand Wash Only",
   "Lay Flat to Dry"
  ]
 }
};
